<template>
  <div class="main">
    <header-t />
    <nav2 />
    <div class="searchbox">
      <el-input
        placeholder="请输入搜索内容"
        v-model="searchText"
        class="search-input"
         ref="inputRef"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          type="primary"
          @click="handleSearch"
        >搜索</el-button>
      </el-input>
    </div>
    <div class="cont">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-if="type === 'notice'">公告</el-breadcrumb-item>
        <el-breadcrumb-item v-if="type === 'news'">资讯搜索</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="item mar-bottom">
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="cardBox">
              
              <div shadow="nerve" class="card cardBoxRight">
                <div class="tabs-cont">
                  <template v-if="rows && rows.length > 0">
                    <div class="art-top" v-for="item in rows" :key="item.rows">
                      <div class="art-intro" @click="goDetail(item.id)">
                        <div class="art-intro-left">
                          {{ item.title }}
                        </div>
                        <div class="art-intrp-right">
                          <div class="icon">
                            <i class="el-icon-time"></i>
                            <span class="icontime">{{ item.updatedTime ? new Date(Number(item.updatedTime*1000)).toLocaleDateString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '-') : '' }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <div v-else class="empty-state">
                    <!-- <img src="@/assets/images/no-data.png" alt="暂无数据" /> -->
                    <p>暂无搜索结果</p>
                  </div>
                </div>
                <div class="pagination" v-if="search.total>search.size">
                  <Pagination :total="search.total" :page.sync="search.page" :limit.sync="search.size"
                    @pagination="getDataList" />
                </div>
              </div>
            </div>
          </el-col>
          <!-- <el-col :span="18">
            
          </el-col> -->
        </el-row>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import HeaderT from '@/components/HeaderT'
import Nav2 from '@/components/Nav2'
import Footer from '@/components/Footer'
import Pagination from '@/components/Pagination'
import {getArticleSearch } from '@/api/index'
// import Swiper from '@/components/VueAwesomeSwiper'
export default {
  name: 'noticeList',
  components: {
    HeaderT,
    Nav2,
    Footer,
    Pagination,
    // Swiper
  },
  data () {
    return {
      info: {},
      noticeId: null,
      activeName: '0',
      search: {
        page: 1,
        size: 20,
      },
      // noticeType: 1,
      rows: [],
      type: '', // 类型
     
      focusData: [], // 焦点
      focuDataMin: [], // 右侧两个推荐位置
      recommendData: [], // 推荐
      categoryId: 0, //0      所有信息（资讯频道页使用）3	行业动态4	政策法规5	招生通知6	报名指南7	操作手册
      bannerdata: [],
      searchText: '' // 添加搜索文本绑定
    }
  },
  created () {
    console.log(this.$route.query.type)
    if (this.$route.query.type) {
      this.type = this.$route.query.type
    }
    if (this.$route.query.tab) {// tab
      this.activeName = '5'
      this.categoryId = 5
    }
    if (this.$route.query.keyword) {
      this.searchText = this.$route.query.keyword
    }
    this.getDataList()
  },
  mounted () {
    this.$refs.inputRef.$el.addEventListener('keyup', this.handleKeyup);
  },
  beforeDestroy() {
    this.$refs.inputRef.$el.removeEventListener('keyup', this.handleKeyup);
  },
  methods: {
    getDataList () {
      this.search.page = this.search.page || 1
      this.search.size = this.search.size || 10
      this.search.title = this.searchText
      getArticleSearch(this.search).then(res => {
        if (res.data.code === 0) {
          this.rows = res.data.data.rows
          this.search.total = res.data.data.total
          // this.$message({
          //   type:'success',
          //   message:res.data.message
          // })
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        }
      })
    },
    handleKeyup(event) {
      if (event.key === 'Enter') {
        this.handleSearch();
      }
    },
    goDetail (id) {
      this.$router.push({
        path: '/article',
        query: {
          newsId: id,
          type: 'news'
        }
      })
    },
    handleSearch() {
      if (!this.searchText.trim()) {
        this.$router.push({
          path: '/news',
          query: {
            type: 'news',
          }
        })
        return
      }
      
      this.$router.push({
        path: '/search',
        query: {
          type: 'news',
          keyword: this.searchText
        }
      })
      this.search.page =  1
      this.search.total = 0
      this.getDataList()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.searchbox {
  position: relative;
  max-height: 580px;
  min-height: 400px;
  background: url(https://zjt.xinjiang.gov.cn/xjzjt/xhtml/images/bg.jpg) no-repeat center;
  background-size: 100% 100%;
  
  .search-input {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
    opacity: 0.9;
    /deep/ .el-input__inner {
      height: 50px;
      font-size: 16px;
    }
    
    /deep/ .el-button {
      height: 50px;
      
    }
  }
}
.main {
  height: 100%;
  background-color: #f5f5f5;

  .cont {
    width: 1170px;
    margin: 20px auto;

    .item {
      margin-top: 20px;

      .cardBox {
        display: flex;
        background: #fff;
        padding: 0px;

        .cardBoxRight {
          background: #fff;
          padding: 20px 20px 20px 30px;
          flex: 1;

          margin-top: 0px !important;
          border-left: 1px solid #eee;
          .tabs-cont{
            min-height: 70vh;
            
            .empty-state {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              padding: 40px 0;
              
              img {
                width: 200px;
                margin-bottom: 20px;
              }
              
              p {
                color: #909399;
                font-size: 14px;
              }
            }
          }
        }
      }

      .card {
        padding: 20px;
        background: #fefefe;

        /* .art-top{
          border-top: 1px solid #ddd;
          margin-top: 1px; */
        .art-intro {
          position: relative;
          text-align: left;
          display: flex;
          justify-content: space-around;
          /* margin-top: 30px; */
          /* width: 825px; */
          height: 55px;
          line-height: 55px;
          /* border-top: 1px solid #ddd; */
          border-bottom: 1px solid #ddd;
          font-size: 14px;

          .art-intro-left {
            width: 65%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
            color: #333;
            text-decoration: none;
            position: relative;
          padding-left: 12px;
          &::before{
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 4px;
              height: 4px;
              background-color: #5c94d8;
              border-radius: 50%;
            }

            a {
              cursor: pointer;
              color: #333;
              text-decoration: none;
              outline: none;
              margin-left: 5px;
            }
          }

          .art-intro-left:hover {
            color: #b7090a;
          }

          .art-intrp-right {
            width: 35%;

            /* display: flex;
            justify-content: space-around; */
            .icon {
              width: 45%;
              font-size: 16px;
              color: #999999;
              float: right;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

              .icontime {
                font-size: 14px;
                margin-left: 10px;
              }
            }
          }
        }

        /* } */
        .pagination {
          margin-top: 30px;
        }

        /deep/ .el-tabs {
          &__item {
            width: 140px;
            text-align: center;
            padding: 0 10px;
            height: 40px;
            line-height: 40px;
          }
          &__nav {
            width: 100%;
          }
          &__active-bar {
            width: 140px !important;
            color: #fff;
            z-index: 1;
          }
          .is-active{
            color: #fff;
            position: relative;
            z-index: 10;
          }
          &__nav-wrap.is-left::after{
            right: -20px !important;
          }
        }
      }

      .card:nth-of-type(n + 2) {
        margin-top: 20px;
      }

      .top20 {
        margin-top: 20px;
      }

      .panel {
        .tit {
          text-align: left;
          line-height: 30px;
          border-bottom: 1px solid #f5f5f5;
        }

        .body {
          padding: 15px 0;

          .media-left {
            display: table-cell;
            vertical-align: top;
            padding-right: 15px;

            .avatar-md {
              width: 60px;
              height: 60px;
              border-radius: 50%;
              margin: 5px;
            }
          }

          .media-member {
            display: table-cell;
            vertical-align: top;

            .avatar-md {
              float: left;
              width: 36px;
              height: 36px;
              border-radius: 50%;
              margin: 5px;
            }
          }

          .dynamic {
            margin-top: 5px;

            li {
              text-align: left;
              font-size: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              word-wrap: normal;
              color: #666;
              border-bottom: 1px #eee dashed;
              height: 30px;
              line-height: 30px;
              margin: 5px 0;
            }

            li:hover {
              color: #b7090a;
              cursor: pointer;
            }
          }

          .media-right {
            display: table-cell;
            vertical-align: top;
            font-size: 14px;

            .title {
              margin: 10px 0 10px 0;
              text-align: left;
            }
          }
        }
      }

      .recommend {
        position: relative;

        .r_tit_bg {
          position: absolute;
          background: #eee;
          width: 100%;
          height: 30px;
          padding-top: 12px;
          opacity: 0.7;
          left: 0px;
          bottom: 0px;

          .r_title {
            color: #333;
            text-indent: 10px;
            width: 310px;
            overflow: hidden;
            /* border:1px #f00 solid; */
            text-align: left;
            white-space: nowrap;
            /* 防止文本换行 */
            overflow: hidden;
            /* 隐藏超出容器的部分 */
            text-overflow: ellipsis;
            /* 显示省略号 */
          }
        }

        .top_img {
          width: 100%;
        }
      }

      .recommend:hover {
        cursor: pointer;
      }
    }

    .mar-bottom {
      margin-bottom: 20px;
    }

    .banner-wrap {
      height: 366px;
    }
  }
}
</style>